import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { LookupModel } from '../../common/models/LookupModel';
import { Store } from '@ngrx/store';

import * as securityStore from '../../security/store/reducers';
import * as fromStore from '../store/reducers';
import { CurrentUserService } from '../../security/services/CurrentUserService';
import { GetCurrentUserSubmittingEntitiesAction } from '../../security/store/actions';
import { SubmittingEntitySelectedAction } from '../store/actions/SubmittingEntitySelectedAction';
import { UserService } from '../../customer/services/UserService';

@Injectable()
export class DataWarehouseContextManagerService {
  submittingEntitiesLoaded$: Observable<boolean>;
  submittingEntities$: Observable<LookupModel[]>;
  allSubmittingEntities$: Observable<LookupModel[]>;
  selectedSubmittingEntity$: Observable<LookupModel>;
  done$: Subject<boolean> = new Subject<boolean>();
  private _loaded: boolean = false;
  private _initialKeyToSelect: string;

  constructor(private store: Store<any>, private currentUserService: CurrentUserService, private userService: UserService) {
    this.submittingEntitiesLoaded$ = this.store.select(securityStore.getUserContextSubmittingEntitiesLoaded);
    this.submittingEntities$ = this.store.select(securityStore.getUserContextSubmittingEntities);
    this.selectedSubmittingEntity$ = this.store.select(fromStore.getSubmittingEntity);
    this.allSubmittingEntities$ = userService.getCurrentUserSubmittingEntities(false).map(r => r.model);
    this.store
      .select(securityStore.getUserContextSubmittingEntitiesLoaded)
      .takeUntil(this.done$)
      .subscribe(() => {
        if (this.currentUserService.userContext.submittingEntitiesLoaded) {
          this._loaded = true;
          if (this._initialKeyToSelect) {
            this.currentUserService.userContext.submittingEntities.forEach(s => {
              if (s.key === this._initialKeyToSelect) {
                this.selectSubmittingEntity(s);
              }
            });
          } else if (this.currentUserService.userContext.submittingEntities.length === 1) {
            this.selectSubmittingEntity(this.currentUserService.userContext.submittingEntities[0]);
          }
          this._initialKeyToSelect = null;
          this.done$.next(true);
        } else {
          this.store.dispatch(new GetCurrentUserSubmittingEntitiesAction());
        }
      });
  }

  selectSubmittingEntity(submittingEntity: LookupModel) {
    this.store.dispatch(
      new SubmittingEntitySelectedAction({
        submittingEntity: submittingEntity,
      }),
    );
  }

  trySelectByKey(submittingEntityKey: string) {
    if (this._loaded) {
      this.currentUserService.userContext.submittingEntities.forEach(s => {
        if (s.key === submittingEntityKey) {
          this.selectSubmittingEntity(s);
        }
      });
    } else {
      this._initialKeyToSelect = submittingEntityKey;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/datawarehouse/service/data-warehouse-context-manager.service.ts